import { IconChevronDown } from '@tabler/icons-react'
import type { ReactNode } from 'react'

import { prettyJson } from '../lib/format'

/** Baris JSON yang bisa dibuka: header dan body komunikasi bank, perubahan audit. */
export function JsonDisclosure({
  summary,
  value,
  meta,
}: {
  summary: string
  value: unknown
  meta?: ReactNode
}) {
  return (
    <details className="disclosure">
      <summary className="disclosure__summary">
        <IconChevronDown size={16} stroke={1.75} aria-hidden="true" />
        {summary}
      </summary>
      {meta ? <div className="row-item__meta">{meta}</div> : null}
      <pre className="code-block">{prettyJson(value)}</pre>
    </details>
  )
}
